module.exports = __webpack_public_path__ + "img/KH.16ccda91.svg";